<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-inline mb-3">
                    <div class="form-group">
                        <label for="search" class="sr-only">Search</label>
                        <input
                            type="text"
                            class="form-control"
                            name="search"
                            id="search"
                            placeholder="Search ..."
                            spellcheck="false"
                            v-model="filters.search"
                            @input="search"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-right">
                <button type="button" class="btn" @click="setAutoRefresh" :disabled="loading"
                        :class="{'disabled': loading, 'btn-outline-success': !auto_refresh, 'btn-success': auto_refresh }">
                    <i class="fas fa-circle-notch mr-1 fa-spin" v-if="auto_refresh"></i>
                    <i class="fas fa-sync-alt mr-1" v-else></i>
                    Auto refresh
                </button>
                <button type="button" class="btn btn-outline-primary" @click="fetch" :disabled="loading"
                        :class="{'disabled': loading}">
                    <i class="fas fa-redo mr-1"></i>
                    Refresh
                </button>
            </div>
        </div>

        <spinner v-if="loading" class="py-5"/>

        <table class="table table-bordered table-hover" v-if="!loading && members.length">
            <thead>
                <tr>
                    <th>Member nickname</th>
                    <th>Member name</th>
                    <th>Work status</th>
                    <th>Sent status</th>
                    <th>Message</th>
                    <th class="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="member in members">
                    <td>{{ member.member.nickname }}</td>
                    <td>{{ member.member.name }}</td>
                    <td>
                        <badge variant="success" v-if="member.status === 'success'">Success</badge>
                        <badge variant="default" v-if="member.status === 'pending'">Pending</badge>
                    </td>
                    <td>
                        <badge variant="success" v-if="member.sent">Sent</badge>
                        <badge variant="default" v-if="!member.sent">Not sent</badge>
                    </td>
                    <td>
                        <div v-if="member.message">
                            <div>#{{ member.message.id }}</div>
                            <div class="font-italic">{{ member.message.text }}</div>
                        </div>
                    </td>
                    <td class="text-center">
                        <button type="button"
                                class="btn btn-outline-danger btn-sm"
                                :disabled="member.sent"
                                :class="{'disabled': member.sent}"
                                @click="removeMember(member.id)">
                            <i class="fas fa-trash mr-1"></i>
                            Remove
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <paginate
            v-if="!loading && total > 1 && members.length"
            :page-count="total"
            :click-handler="changePage"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :prev-text="'Prev'"
            :next-text="'Next'">
        </paginate>

        <h4
            class="text-center text-muted py-5 border m-0"
            v-if="!loading && !members.length"
        >No records.</h4>
    </div>
</template>

<script>
import SweetAlert from "./../SweetAlert";

export default {
    props: ['campaign-id'],

    data() {
        return {
            members: [],
            loading: false,
            searching: false,
            auto_refresh: false,
            total: 0,
            filters: {
                search: '',
                page: 1,
            },
        };
    },
    methods: {
        changePage(pageNum) {
            this.filters.page = pageNum;
            this.stopAutoRefresh();
            this.fetch(false);
        },
        setAutoRefresh() {
            this.auto_refresh = !this.auto_refresh;
            this.$emit('auto_refresh', this.auto_refresh);
        },
        stopAutoRefresh() {
            this.auto_refresh = false;
            this.$emit('auto_refresh', this.auto_refresh);
        },
        search: _.debounce(function () {
            this.searching = true;
            this.stopAutoRefresh();
            this.filters.page = 1;
            this.fetch(false);
        }, 500),
        fetch(withLoader = true) {
            if (withLoader) {
                this.loading = true;
            }

            return axios.get(`/api/campaigns/${this.campaignId}/members`, {
                params: this.filters
            }).then(response => {
                this.members = response.data.data;
                this.loading = false;
                this.searching = false;
                this.total = response.data.meta.last_page;
                this.filters.page = response.data.meta.current_page;

                return response;
            }).catch(() => {
                this.loading = false;
                this.searching = false;
            });
        },
        removeMember(id) {
            SweetAlert.confirm().then(result => {
                if (result.isConfirmed) {
                    axios.delete(`/api/campaigns/${this.campaignId}/members/${id}`).then(() => {
                        this.fetch(false);
                    });
                }
            });
        }
    },

    mounted() {
        this.fetch();

        this.$on('auto_refresh', (payload) => {
            if (payload) {
                this.timer = setInterval(() => {
                    this.fetch(false);
                }, 3000);
            } else {
                clearInterval(this.timer);
            }
        });
    }
}
</script>
